'use strict';
module.exports = require('./SelectButton.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/selectbutton/index.js
// module id = 1526
// module chunks = 1